import React, { Component, useEffect, useState } from 'react';
import { Platform, ScrollView, TouchableOpacity, } from 'react-native';
import { Icon, Button, Text, ListItem, NativeBaseProvider, View, Avatar, useSafeArea, Image, FlatList, Divider } from 'native-base';
import db from '../acebase';
import { liveTTScoreboardTheme } from "../liveTTScoreboardTheme";
import pingPongTableSVG from './img/pingpongtable.svg'
import teamMatchSVG from './img/teammatch2.svg'
import teamsSVG from './img/teams.svg'
import scoreboardSVG from './img/scoreboard.svg'
import playersSVG from './img/players.svg'
import informationSVG from './img/information.svg'
import bracketSVG from './img/bracket.svg'
import accountSVG from './img/account.svg'
import dynamicurlSVG from './img/dynamicurl.svg'
import firebase from 'firebase';

import i18n from './translations/translate';

export default function Home(props) {

    const scoringScreens = [
        {
            route: "MyTables",
            title: i18n.t("tables"),
            description: i18n.t("tableDescription"),
            icon: pingPongTableSVG
        },
        {
            route: "MyTeamMatches",
            title: i18n.t("teamMatches"),
            description: i18n.t("teamMatchDescription"),
            icon:teamMatchSVG
        },
    ]
    const importables = [
         {
            route:"MyPlayerLists",
            title: i18n.t("players"),
            description: i18n.t("playersDescription"),
            icon:playersSVG
        },
        {
            route: "MyTeams",
            title: i18n.t("teams"),
            description: i18n.t("teamDescription"),
            icon:teamsSVG
        },
        
    ]
    const scoreboards = [
        {
            route: "MyScoreboards",
            title: i18n.t("scoreboards"),
            description:i18n.t("scoreboardsDescription"),
            icon:scoreboardSVG
        },
        {
            route: "DynamicURLS",
            title: "Dynamic URLs",
            description: "Change Tables/Team Matches, same URL.",
            icon:dynamicurlSVG
        }
    ]

    const account = [
          
        {
            route: "MyAccount",
            title: i18n.t("accountSettings"),
            description: i18n.t("accountSettingsDescription"),
            icon: accountSVG
        },
        {
            route: "",
            title: `${i18n.t("tutorials")}(${i18n.t("comingSoon")})`,
            description: i18n.t("tutorialsDescription"),
            icon:informationSVG
        },
    ]

    const homeScreenOptions = [
        
       
        
      
    ]
    if (Platform.OS === "web") {
        //console.log(window.location.host+flagRoute)
    }
    useEffect(() => {
        // loadTWFlag()
    }, [])
    return (
        <NativeBaseProvider theme={liveTTScoreboardTheme}>
            <View 
            >
                <View>
                    <Text fontSize={"2xl"} textAlign="center" underline fontWeight={"bold"}>{i18n.t("scoring")}</Text>
                </View>
                <View flexDirection={"row"} flexWrap="wrap" alignItems={"center"} justifyContent="center" >

                
                {
                    scoringScreens.map((scoringItem)=>{
                        return(
                            <TouchableOpacity key={scoringItem.title}
                        onPress={()=>{
                            props.navigation.navigate(scoringItem.route)
                        }}
                        >
                    <View padding={2} justifyContent="center" alignItems={"center"}>
                    <Image size={"md"}  borderRadius={"none"} source={scoringItem.icon}></Image>
                    <Text textAlign={"center"} fontSize="xl" fontWeight={"bold"} >{scoringItem.title}</Text>
                    <Text fontSize={"xs"} textAlign={"center"}>{scoringItem.description}</Text>
                </View>
                </TouchableOpacity>
                        )
                        
                    })
                }
                </View>

                <View>
                    <Text fontSize={"2xl"} textAlign="center" underline fontWeight={"bold"}>{i18n.t("importablePlayersTeams")}</Text>
                </View>
                <View flexDirection={"row"} flexWrap="wrap" alignItems={"center"} justifyContent="center" >

                
                {
                    importables.map((scoringItem)=>{
                        return(
                            <TouchableOpacity key={scoringItem.title}
                        onPress={()=>{
                            props.navigation.navigate(scoringItem.route)
                        }}
                        >
                    <View padding={2} justifyContent="center" alignItems={"center"}>
                    <Image size={"md"}  borderRadius={"none"} source={scoringItem.icon}></Image>
                    <Text textAlign={"center"} fontSize="xl" fontWeight={"bold"} >{scoringItem.title}</Text>
                    <Text fontSize={"xs"} textAlign={"center"}>{scoringItem.description}</Text>
                </View>
                </TouchableOpacity>
                        )
                        
                    })
                }
                </View>

                <View>
                    <Text fontSize={"2xl"} textAlign="center" underline fontWeight={"bold"}>{i18n.t("scoreboardsOverlays")}</Text>
                </View>
                <View flexDirection={"row"} flexWrap="wrap" alignItems={"center"} justifyContent="center" >

                
                {
                    scoreboards.map((scoringItem)=>{
                        return(
                            <TouchableOpacity key={scoringItem.title}
                        onPress={()=>{
                            if(scoringItem.route.length > 0){
                               props.navigation.navigate(scoringItem.route) 
                            }
                            
                        }}
                        >
                    <View padding={2} justifyContent="center" alignItems={"center"}>
                    <Image size={"md"}  borderRadius={"none"} source={scoringItem.icon}></Image>
                    <Text textAlign={"center"} fontSize="xl" fontWeight={"bold"} >{scoringItem.title}</Text>
                    <Text fontSize={"xs"} textAlign={"center"}>{scoringItem.description}</Text>
                </View>
                </TouchableOpacity>
                        )
                        
                    })
                }
                </View>

                <View>
                    <Text fontSize={"2xl"} textAlign="center" underline fontWeight={"bold"}>{i18n.t("account")}</Text>
                </View>
                <View flexDirection={"row"} flexWrap="wrap" alignItems={"center"} justifyContent="center" >

                
                {
                    account.map((scoringItem)=>{
                        return(
                            <TouchableOpacity key={scoringItem.title}
                        onPress={()=>{
                            if(scoringItem.route.length > 0){
                               props.navigation.navigate(scoringItem.route) 
                            }
                            
                        }}
                        >
                    <View padding={2} justifyContent="center" alignItems={"center"}>
                    <Image size={"md"}  borderRadius={"none"} source={scoringItem.icon}></Image>
                    <Text textAlign={"center"} fontSize="xl" fontWeight={"bold"} >{scoringItem.title}</Text>
                    <Text fontSize={"xs"} textAlign={"center"}>{scoringItem.description}</Text>
                </View>
                </TouchableOpacity>
                        )
                        
                    })
                }
                </View>
                
                <FlatList
                data={homeScreenOptions}
                renderItem={(item)=>{
                    return (
                            <View >
                                <TouchableOpacity 
                                onPress={() => {
                                    props.navigation.navigate(item.item.route)
                                }}
                            >
                                <View flexDirection={"column"} flex={1}>
                                    <Text fontSize={"xl"}>{item.item.title}</Text>
                                    <Text textAlign={"center"} fontSize={"sm"}>{item.item.description}</Text>
                                </View>
                            </TouchableOpacity>
                            <Divider></Divider>
                            </View>
                            
                     
                    )
                }}
                ></FlatList>
                {/* <View flexDirection="column">

                    <View>
                        <TouchableOpacity>
                            <Text></Text>
                        </TouchableOpacity>
                    </View>
                    <View padding={1}>
                        <View padding={0.5} borderRadius={10} borderColor={"black"} borderWidth={3}>
                            <TouchableOpacity
                                onPress={() => {
                                    props.navigation.navigate("MyTables")
                                }}
                            >
                                <View flexDirection={"column"} flex={1} backgroundColor="red.100" padding={10}>
                                    <Text fontSize={"xl"}>My Tables</Text>
                                    <Text textAlign={"center"} fontSize={"sm"}>Keep Score, manage tables, and matches.</Text>
                                </View>
                            </TouchableOpacity>
                        </View>
                    </View>
                    <View padding={1}>
                        <View padding={0.5} borderRadius={10} borderColor={"black"} borderWidth={3}>
                            <TouchableOpacity
                                onPress={() => {
                                    props.navigation.navigate("MyTeamMatches")
                                }}
                            >
                                <View flexDirection={"column"} flex={1} backgroundColor="red.100" padding={10}>
                                    <Text fontSize={"xl"}>My Team Matches</Text>
                                    <Text textAlign={"center"} fontSize={"sm"}>Team vs Team Competitions, manage team matches.</Text>
                                </View>
                            </TouchableOpacity>
                        </View>
                    </View>
                    <View padding={1}>
                        <View padding={0.5} borderRadius={10} borderColor={"black"} borderWidth={3}>
                            <TouchableOpacity
                                onPress={() => {
                                    props.navigation.navigate("MyTeams")
                                }}
                            >
                                <View flexDirection={"column"} flex={1} padding={10}>
                                    <Text fontSize={"xl"}>My Teams</Text>
                                    <Text textAlign={"center"} fontSize={"sm"}>Setup Teams Ahead of time, and reuse them for team matches.</Text>
                                </View>
                            </TouchableOpacity>
                        </View>
                    </View>
                    <View padding={1}>
                        <View padding={10} borderRadius={10} borderColor={"black"} borderWidth={3}>
                            <TouchableOpacity
                                onPress={() => {
                                    props.navigation.navigate("MyScoreboards")
                                }}
                                style={{ flexDirection: "column", }}>
                                <Text fontSize={"xl"}>My Scoreboards</Text>
                                <Text textAlign={"center"} fontSize={"sm"}>View, edit, and customize your scoreboards.</Text>
                            </TouchableOpacity>
                        </View>

                    </View>

                </View> */}
                {/* {
                doneLoadingPhoto ?
                                 <Image  width={100} style={{aspectRatio:"3/2"}} source={flagRoute} />
:null
              } */}
                {
                    firebase.default.auth().currentUser.email === "jackbmccarthy@gmail.com" ?
                    <Button
                    onPress={()=>{
                        props.navigation.navigate("BulkAddPlayer") 
                    }}
                    >
                        <Text>Bulk Add</Text>
                    </Button>

                    : null
                }

            </View>
        </NativeBaseProvider>
    )
}